import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { searchItems } from "@/utils/searchHelpers";
import { getStep, getRescheduleTimes } from "@/apis/sell-my-car";
import { useSearchParams } from "react-router-dom";
import erp_workshop_locations from "@data/lookups/erp_workshop_locations.json";
import erp_cities_with_areas from "@data/lookups_language_customized/erp_cities_with_areas.json";
var SellCarDataContext = /*#__PURE__*/createContext(undefined);
export function useSellCarData() {
  var context = useContext(SellCarDataContext);
  if (!context) {
    throw new Error("useSellCarData must be used within SellCarDataProvider");
  }
  return context;
}
export function SellCarDataProvider(_ref) {
  var _draftOrder$currentSt3, _draftOrder$currentSt4, _draftOrder$currentSt7, _draftOrder$currentSt8, _selection$make2, _selection$model2;
  var children = _ref.children;
  var _useState = useState(null),
    brandsData = _useState[0],
    setBrandsData = _useState[1];
  var _useState2 = useState(Array.from({
      length: 20
    }, function (_, i) {
      return new Date().getFullYear() - i;
    })),
    years = _useState2[0],
    setYears = _useState2[1];
  var _useState3 = useState(true),
    isLoading = _useState3[0],
    setIsLoading = _useState3[1];
  var _useState4 = useState(null),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState([]),
    odometerRanges = _useState5[0],
    setOdometerRanges = _useState5[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useState6 = useState({
      make: null,
      model: null,
      extension: null,
      year: null,
      odometerRange: null,
      ownership: null,
      selectedCityForInspection: null
    }),
    selection = _useState6[0],
    setSelection = _useState6[1];
  var _useState7 = useState([]),
    availableModels = _useState7[0],
    setAvailableModels = _useState7[1];
  var _useState8 = useState([]),
    availableExtensions = _useState8[0],
    setAvailableExtensions = _useState8[1];
  var _useState9 = useState([]),
    availableTimes = _useState9[0],
    setAvailableTimes = _useState9[1];
  var _useState0 = useState(false),
    isLoadingTimes = _useState0[0],
    setIsLoadingTimes = _useState0[1];
  var _useState1 = useState(false),
    isOtpVisible = _useState1[0],
    setIsOtpVisible = _useState1[1];
  var _useState10 = useState({
      isDraft: false,
      requestId: (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get("request_id")) || null,
      contactInfo: null,
      previousStep: null,
      currentStep: null,
      isLoadingStepData: false,
      inspectionLocation: null
    }),
    draftOrder = _useState10[0],
    setDraftOrderState = _useState10[1];
  var workShopLocations = useMemo(function () {
    // return erp_workshop_locations.filter((location) => location.name ==  cityId);
    return erp_workshop_locations === null || erp_workshop_locations === void 0 ? void 0 : erp_workshop_locations.filter(function (workshop_location) {
      var _draftOrder$currentSt, _draftOrder$currentSt2;
      return workshop_location.city_id == (draftOrder === null || draftOrder === void 0 ? void 0 : (_draftOrder$currentSt = draftOrder.currentStep) === null || _draftOrder$currentSt === void 0 ? void 0 : (_draftOrder$currentSt2 = _draftOrder$currentSt.data) === null || _draftOrder$currentSt2 === void 0 ? void 0 : _draftOrder$currentSt2.city_id);
    });
  }, [draftOrder === null || draftOrder === void 0 ? void 0 : (_draftOrder$currentSt3 = draftOrder.currentStep) === null || _draftOrder$currentSt3 === void 0 ? void 0 : (_draftOrder$currentSt4 = _draftOrder$currentSt3.data) === null || _draftOrder$currentSt4 === void 0 ? void 0 : _draftOrder$currentSt4.city_id]);

  // Load brands data - ALWAYS load Arabic file for bilingual search support
  // Arabic file contains: name (Arabic) + seo_url (English)
  // This allows searching in both languages with a single file
  useEffect(function () {
    var loadBrandsData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _odometerRanges, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              setIsLoading(true);
              setError(null);
              _context.p = 1;
              _context.n = 2;
              return import("@data/lookups/brands_tree_ar.json");
            case 2:
              data = _context.v;
              _context.n = 3;
              return import("@data/lookups/erp_odometer_ranges.json");
            case 3:
              _odometerRanges = _context.v;
              setBrandsData(data);
              setOdometerRanges(_toConsumableArray(_odometerRanges["default"]));
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              setError(_t instanceof Error ? _t : new Error("Unknown error loading brands data"));
              console.error("Error loading brands data:", _t);
            case 5:
              _context.p = 5;
              setIsLoading(false);
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[1, 4, 5, 6]]);
      }));
      return function loadBrandsData() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadBrandsData();
  }, []); // Only load once on mount

  // Update available models when make is selected
  useEffect(function () {
    if (!brandsData || !selection.make) {
      setAvailableModels([]);
      return;
    }
    var models = brandsData.models.filter(function (model) {
      return model.make_id === selection.make.id;
    });
    setAvailableModels(models);
  }, [brandsData, selection.make]);

  // Update available extensions when model is selected
  useEffect(function () {
    if (!brandsData || !selection.model) {
      setAvailableExtensions([]);
      return;
    }
    var extensions = brandsData.extensions.filter(function (extension) {
      return extension.model_id === selection.model.id;
    });
    setAvailableExtensions(extensions);
  }, [brandsData, selection.model]);
  var checkCityAllowedForInspection = useMemo(function () {
    var _selectedCity$allowed, _selectedCity$allowed2, _selectedCity$allowed3, _selectedCity$allowed4, _selectedCity$allowed5, _selectedCity$allowed6;
    var selectedCity = erp_cities_with_areas === null || erp_cities_with_areas === void 0 ? void 0 : erp_cities_with_areas.ar.find(function (city) {
      var _draftOrder$currentSt5, _draftOrder$currentSt6;
      return (city === null || city === void 0 ? void 0 : city.id) === (draftOrder === null || draftOrder === void 0 ? void 0 : (_draftOrder$currentSt5 = draftOrder.currentStep) === null || _draftOrder$currentSt5 === void 0 ? void 0 : (_draftOrder$currentSt6 = _draftOrder$currentSt5.data) === null || _draftOrder$currentSt6 === void 0 ? void 0 : _draftOrder$currentSt6.city_id);
    });
    return {
      company_location: (selectedCity === null || selectedCity === void 0 ? void 0 : (_selectedCity$allowed = selectedCity.allowed_inspection_location) === null || _selectedCity$allowed === void 0 ? void 0 : (_selectedCity$allowed2 = _selectedCity$allowed[0]) === null || _selectedCity$allowed2 === void 0 ? void 0 : (_selectedCity$allowed3 = _selectedCity$allowed2.company_location) === null || _selectedCity$allowed3 === void 0 ? void 0 : _selectedCity$allowed3.status) === "True",
      customer_location: (selectedCity === null || selectedCity === void 0 ? void 0 : (_selectedCity$allowed4 = selectedCity.allowed_inspection_location) === null || _selectedCity$allowed4 === void 0 ? void 0 : (_selectedCity$allowed5 = _selectedCity$allowed4[0]) === null || _selectedCity$allowed5 === void 0 ? void 0 : (_selectedCity$allowed6 = _selectedCity$allowed5.customer_location) === null || _selectedCity$allowed6 === void 0 ? void 0 : _selectedCity$allowed6.status) === "True"
    };
  }, [draftOrder === null || draftOrder === void 0 ? void 0 : (_draftOrder$currentSt7 = draftOrder.currentStep) === null || _draftOrder$currentSt7 === void 0 ? void 0 : (_draftOrder$currentSt8 = _draftOrder$currentSt7.data) === null || _draftOrder$currentSt8 === void 0 ? void 0 : _draftOrder$currentSt8.city_id]);

  // Check if any selection has been made (excluding selectedCityForInspection)
  var haveSelection = useMemo(function () {
    return !!(selection.make || selection.model || selection.extension || selection.year || selection.odometerRange || selection.ownership);
  }, [selection.make, selection.model, selection.extension, selection.year, selection.odometerRange, selection.ownership]);
  var selectMake = function selectMake(make) {
    setSelection({
      make: make,
      model: null,
      extension: null,
      year: null,
      odometerRange: null,
      ownership: null,
      selectedCityForInspection: null
    });
  };
  var selectModel = function selectModel(model) {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        model: model,
        extension: null,
        year: null,
        odometerRange: null,
        ownership: null
      });
    });
  };
  var selectExtension = function selectExtension(extension) {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        extension: extension,
        year: null,
        odometerRange: null,
        ownership: null
      });
    });
  };
  var selectYear = function selectYear(year) {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        year: year,
        odometerRange: null,
        ownership: null
      });
    });
  };
  var selectOdometer = function selectOdometer(range) {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        odometerRange: range,
        ownership: null
      });
    });
  };
  var selectOwnership = function selectOwnership(ownership) {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        ownership: ownership
      });
    });
  };
  var clearFromMake = function clearFromMake() {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        make: null,
        model: null,
        extension: null,
        year: null,
        odometerRange: null,
        ownership: null
      });
    });
  };
  var clearFromModel = function clearFromModel() {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        model: null,
        extension: null,
        year: null,
        odometerRange: null,
        ownership: null
      });
    });
  };
  var clearFromExtension = function clearFromExtension() {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        extension: null,
        year: null,
        odometerRange: null,
        ownership: null
      });
    });
  };
  var clearFromYear = function clearFromYear() {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        year: null,
        odometerRange: null,
        ownership: null
      });
    });
  };
  var clearFromOdometer = function clearFromOdometer() {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        odometerRange: null,
        ownership: null
      });
    });
  };
  var clearFromOwnership = function clearFromOwnership() {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        ownership: null
      });
    });
  };
  var setCityForInspection = function setCityForInspection(city) {
    setSelection(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        selectedCityForInspection: city
      });
    });
  };

  // Search methods - optimized with useCallback to prevent re-creation
  var searchMakes = useCallback(function (searchTerm) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    if (!(brandsData !== null && brandsData !== void 0 && brandsData.makes)) {
      return [];
    }
    var results = searchItems(brandsData.makes, searchTerm, limit);
    return results;
  }, [brandsData === null || brandsData === void 0 ? void 0 : brandsData.makes]);
  var searchModels = useCallback(function (searchTerm) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    if (!(brandsData !== null && brandsData !== void 0 && brandsData.models)) return [];

    // Filter by makeId if provided
    var filteredModels = selection !== null && selection !== void 0 && selection.make ? brandsData.models.filter(function (model) {
      var _selection$make;
      return model.make_id === (selection === null || selection === void 0 ? void 0 : (_selection$make = selection.make) === null || _selection$make === void 0 ? void 0 : _selection$make.id);
    }) : brandsData.models;
    return searchItems(filteredModels, searchTerm, limit);
  }, [brandsData === null || brandsData === void 0 ? void 0 : brandsData.models, selection === null || selection === void 0 ? void 0 : (_selection$make2 = selection.make) === null || _selection$make2 === void 0 ? void 0 : _selection$make2.id]);
  var searchExtensions = useCallback(function (searchTerm) {
    var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    if (!(brandsData !== null && brandsData !== void 0 && brandsData.extensions)) return [];

    // Filter by modelId if provided
    var filteredExtensions = selection !== null && selection !== void 0 && selection.model ? brandsData.extensions.filter(function (extension) {
      var _selection$model;
      return extension.model_id === (selection === null || selection === void 0 ? void 0 : (_selection$model = selection.model) === null || _selection$model === void 0 ? void 0 : _selection$model.id);
    }) : brandsData.extensions;

    // Note: Extensions don't have seo_url, only name
    // For extensions, we'll search by name only
    return filteredExtensions.filter(function (ext) {
      return ext.name.toLowerCase().includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase());
    }).slice(0, limit);
  }, [brandsData === null || brandsData === void 0 ? void 0 : brandsData.extensions, selection === null || selection === void 0 ? void 0 : (_selection$model2 = selection.model) === null || _selection$model2 === void 0 ? void 0 : _selection$model2.id]);
  var searchYear = useCallback(function (searchTerm, limit) {
    return years.filter(function (y) {
      if (y.toString().includes(searchTerm)) {
        return y;
      }
    });
  }, []);

  // Clear forward data based on the screen we're navigating to
  // This is called when navigating back to ensure data consistency
  var clearForwardDataFromScreen = useCallback(function (screenName) {
    // Screen flow order:
    // car-make -> car-model -> car-extension -> car-year -> car-odometer -> car-ownership -> contact-info

    switch (screenName) {
      case "car-make":
        // Clear everything after make
        clearFromMake();
        break;
      case "car-model":
        // Clear everything after model
        clearFromModel();
        break;
      case "car-extension":
        // Clear everything after extension
        clearFromExtension();
        break;
      case "car-year":
        // Clear everything after year
        clearFromYear();
        break;
      case "car-odometer":
        // Clear everything after odometer
        clearFromOdometer();
        break;
      case "car-ownership":
        // Clear everything after ownership
        clearFromOwnership();
        break;
      case "user_info":
        // Last screen, nothing to clear
        break;
      default:
        console.warn("Unknown screen: ".concat(screenName));
    }
  }, []);

  // Draft order management
  var setDraftOrder = useCallback(function (requestId, contactInfo) {
    setDraftOrderState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isDraft: true,
        requestId: requestId,
        contactInfo: contactInfo
      });
    });
  }, []);

  // Save contact info without requiring a requestId (for when navigating to not-approved screen)
  var setContactInfo = useCallback(function (contactInfo) {
    setDraftOrderState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        contactInfo: contactInfo
      });
    });
  }, []);
  var setStepNavigation = useCallback(function (previousStep, currentStep) {
    setDraftOrderState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        previousStep: previousStep,
        currentStep: currentStep
      });
    });
  }, []);
  var setInspectionLocation = useCallback(function (inspectionLocation) {
    setDraftOrderState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        inspectionLocation: inspectionLocation
      });
    });
  }, []);
  var fetchStepData = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var currentRequestId, landingPageParam, _res$data, params, res, data, _data$current_step, _data$current_step$da, _data$current_step2, stepData, make, model, extension, odometerRange, year, ownership, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          currentRequestId = searchParams.get("request_id");
          landingPageParam = searchParams.get("landing_page"); // Set loading state
          setDraftOrderState(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              isLoadingStepData: true
            });
          });
          if (currentRequestId) {
            _context2.n = 1;
            break;
          }
          console.error("No request_id found in URL");
          setDraftOrderState(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              isLoadingStepData: false
            });
          });
          return _context2.a(2);
        case 1:
          _context2.p = 1;
          params = {
            request_id: currentRequestId
          }; // Add landing_page parameter if it's "true" in URL
          if (landingPageParam === "true") {
            params.landing_page = true;
          }
          _context2.n = 2;
          return getStep(params);
        case 2:
          res = _context2.v;
          data = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
          if (!data) {
            _context2.n = 3;
            break;
          }
          setDraftOrderState(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              isDraft: true,
              requestId: currentRequestId,
              previousStep: data.previous_step || null,
              currentStep: data.current_step || null,
              isLoadingStepData: false
            });
          });

          // Set initial available times
          setAvailableTimes(((_data$current_step = data.current_step) === null || _data$current_step === void 0 ? void 0 : (_data$current_step$da = _data$current_step.date_and_time) === null || _data$current_step$da === void 0 ? void 0 : _data$current_step$da.available_times) || []);

          // Populate selection data from API response
          stepData = (_data$current_step2 = data.current_step) === null || _data$current_step2 === void 0 ? void 0 : _data$current_step2.data;
          if (stepData && brandsData) {
            // Find make by ID
            make = stepData.car_make_id ? brandsData.makes.find(function (m) {
              return m.id === stepData.car_make_id;
            }) : null; // Find model by ID
            model = stepData.car_model_id ? brandsData.models.find(function (m) {
              return m.id === stepData.car_model_id;
            }) : null; // Find extension/trim by ID
            extension = stepData.car_trim_id ? brandsData.extensions.find(function (e) {
              return e.id === stepData.car_trim_id;
            }) : null; // Find odometer range by ID
            odometerRange = stepData.odometer_range_id ? odometerRanges.find(function (o) {
              return o.range === stepData.odometer_range_id;
            }) : null; // Parse year
            year = stepData.year ? parseInt(stepData.year) : null; // Get ownership type
            ownership = stepData.ownership_type || null; // Update selection if we have at least the make
            if (make) {
              setSelection({
                make: make,
                model: model,
                extension: extension,
                year: year,
                odometerRange: odometerRange,
                ownership: ownership,
                selectedCityForInspection: null
              });
            }
          }
          return _context2.a(2, data);
        case 3:
          console.error("No data in response:", res);
          setDraftOrderState(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              isLoadingStepData: false
            });
          });
        case 4:
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t2 = _context2.v;
          console.error("Error fetching step data:", _t2);
          setDraftOrderState(function (prev) {
            return _objectSpread(_objectSpread({}, prev), {}, {
              isLoadingStepData: false
            });
          });
        case 6:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 5]]);
  })), [searchParams, brandsData, odometerRanges]);
  var setDraftOrderFullData = useCallback(function (draftOrderData) {
    setDraftOrderState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), draftOrderData);
    });
  }, []);
  var setPaymentRedirectParams = useCallback(function (params) {
    setDraftOrderState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        paymentRedirectParams: params
      });
    });
  }, []);
  var fetchRescheduleTimes = useCallback(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(day) {
      var currentRequestId, _res$data2, res, _res$data3, _res$data4, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            currentRequestId = searchParams.get("request_id");
            if (currentRequestId) {
              _context3.n = 1;
              break;
            }
            console.error("No request_id found in URL");
            return _context3.a(2, null);
          case 1:
            // Set loading state
            setIsLoadingTimes(true);
            _context3.p = 2;
            _context3.n = 3;
            return getRescheduleTimes({
              day: day,
              request_id: currentRequestId
            });
          case 3:
            res = _context3.v;
            if (!(res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.data)) {
              _context3.n = 4;
              break;
            }
            // Update the availableTimes state
            setAvailableTimes((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data);
            setIsLoadingTimes(false);
            return _context3.a(2, (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data);
          case 4:
            console.warn("No available_times in response");
            setIsLoadingTimes(false);
          case 5:
            return _context3.a(2, null);
          case 6:
            _context3.p = 6;
            _t3 = _context3.v;
            console.error("Error fetching reschedule times:", _t3);
            setIsLoadingTimes(false);
            return _context3.a(2, null);
        }
      }, _callee3, null, [[2, 6]]);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [searchParams]);
  var state = {
    brandsData: brandsData,
    isLoading: isLoading,
    error: error,
    selection: selection,
    availableModels: availableModels,
    availableExtensions: availableExtensions,
    years: years,
    odometerRanges: odometerRanges,
    draftOrder: draftOrder,
    workShopLocations: workShopLocations,
    availableTimes: availableTimes,
    isLoadingTimes: isLoadingTimes,
    haveSelection: haveSelection,
    isOtpVisible: isOtpVisible
  };
  var actions = {
    selectMake: selectMake,
    selectModel: selectModel,
    selectExtension: selectExtension,
    selectOdometer: selectOdometer,
    selectYear: selectYear,
    selectOwnership: selectOwnership,
    clearFromMake: clearFromMake,
    clearFromModel: clearFromModel,
    clearFromExtension: clearFromExtension,
    clearFromYear: clearFromYear,
    clearFromOdometer: clearFromOdometer,
    clearFromOwnership: clearFromOwnership,
    clearForwardDataFromScreen: clearForwardDataFromScreen,
    searchMakes: searchMakes,
    searchModels: searchModels,
    searchExtensions: searchExtensions,
    searchYear: searchYear,
    setDraftOrder: setDraftOrder,
    setContactInfo: setContactInfo,
    setStepNavigation: setStepNavigation,
    fetchStepData: fetchStepData,
    fetchRescheduleTimes: fetchRescheduleTimes,
    checkCityAllowedForInspection: checkCityAllowedForInspection,
    setInspectionLocation: setInspectionLocation,
    setCityForInspection: setCityForInspection,
    setDraftOrderFullData: setDraftOrderFullData,
    setIsOtpVisible: setIsOtpVisible,
    setPaymentRedirectParams: setPaymentRedirectParams
  };
  return /*#__PURE__*/React.createElement(SellCarDataContext.Provider, {
    value: {
      state: state,
      actions: actions
    }
  }, children);
}